import { useLang } from '@/app/utils/useLang';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import gtm from '@/utils/gtm';

export default function OverviewNav({
    activeTab,
    onChange,
    onTabChange,
}: {
    activeTab: string;
    onChange?: (active: string) => void;
    onTabChange?: (active: string) => void;
}) {
    const { locale = 'us', pathname, query } = useRouter();
    const { t } = useLang('theProduct.overview');
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);

    const dataA: EcoNavProductProps = {
        theme: 'black',
        productItems: [
            {
                value: 'stream',
                label: t('overview_name'),
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'stream1',
                label: t('overview_name1'),
                href: query?.debug ? `/${locale}/stream-microinverter?debug=${query.debug}` : `/${locale}/stream-microinverter`,
            },
        ],
        tabItems: [
            {
                value: 'Overview',
                label: t('overview_main'),
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Specs',
                label: t('overview_specs'),
                href: `${thePageUrl}/specs`,
            },
            {
                value: 'Support',
                label: t('overview_support'),
                href: `${thePageUrl}/support`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: t('overview_buynow'),
                href: '#Products',
            },
        ],
    };
    const tabChange = (item: any, index: number) => {
        onTabChange && onTabChange(item.value);
    };
    const handleProductChange = (item: any) => {
        onChange && onChange(item.value);
    };
    const handleBuy = () => {
        gtm.push({
            // event: 'uaEvent',
            // event_name: 'buy',
            // product_name: t('overview_name'),
            // position: `Product Detail_${t('overview_name')}`,

            event: 'uaEvent',
            event_name: 'click_anchor',
            position: `Choose Your Plug-and-Play Home Solar System with Storage`,
            button_name: t('overview_buynow'),
        });
    };
    return (
        <>
            <div className={styles.comp}>
                <EcoNavProduct
                    {...dataA}
                    onBuyChange={handleBuy}
                    defaultTabActiveKey={activeTab}
                    onProductChange={handleProductChange}
                    onTabChange={tabChange}
                />
            </div>
        </>
    );
}
